import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { history } from '../history';
import { connect, useDispatch } from 'react-redux';
import { Link, Route, Router, Switch, useLocation, useParams } from 'react-router-dom';
import { ProgramConstant } from '../redux/reducers';
import { COUNTRIES } from '../config/country';
import { API } from '../config/api';
import { COLORS } from '../config/color';
import RTTable from '../libs/table';
import { RTGroup } from '../libs/string';
import { FaPencilAlt, FaSave } from 'react-icons/fa';
import { RTButton } from '../libs/button';
import { idData, fetchData, updateData } from '../libs/db';
import { Store } from '../store'

const CompPartnerInfo = ({ user, title, partner, allusers }) => {

	const dispatch = useDispatch();

	const [t] = useTranslation(['translation']);
	const [ items, setItems ] = useState([]);
	const [ edit, setEdit ] = useState(false);
	const [ data, setData ] = useState({
		name : "",
	});
	const [ process, setProcess ] = useState(false);

	useEffect(() => {
		setData({ name : partner.name });
	}, [partner]);

	const update = async () => {
		setProcess(true);

		const retpartner = await updateData("rayteams-partner", {
			_id : partner._id,
			sk : "info"
		}, data);

		console.log(retpartner);

		dispatch({ type : ProgramConstant.PARTNERUPDATE, partner : retpartner });

		setProcess(false);

		setEdit(false);
	}

	return <div className="card mb-5 shadow">
		<div className="card-header">
			<div className="card-title">{title}</div>
			<div className="card-toolbar">
				{edit && <>
					<RTButton options={{
						label : t("Cancel"),
						color : COLORS.SECONDARY,
						size : "sm",
						action : () => setEdit(false)
					}} css="me-2" />
					<RTButton options={{
						label : <>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
								<path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
							</svg> {t("Update")}</>,
						size : "sm",
						action : () => update(),
						needValid : true
					}} valid={data.name} />
				</>}
				{!edit && <RTButton options={{
					label : <>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M2 4.63158C2 3.1782 3.1782 2 4.63158 2H13.47C14.0155 2 14.278 2.66919 13.8778 3.04006L12.4556 4.35821C11.9009 4.87228 11.1726 5.15789 10.4163 5.15789H7.1579C6.05333 5.15789 5.15789 6.05333 5.15789 7.1579V16.8421C5.15789 17.9467 6.05333 18.8421 7.1579 18.8421H16.8421C17.9467 18.8421 18.8421 17.9467 18.8421 16.8421V13.7518C18.8421 12.927 19.1817 12.1387 19.7809 11.572L20.9878 10.4308C21.3703 10.0691 22 10.3403 22 10.8668V19.3684C22 20.8218 20.8218 22 19.3684 22H4.63158C3.1782 22 2 20.8218 2 19.3684V4.63158Z" fill="currentColor"></path>
							<path d="M10.9256 11.1882C10.5351 10.7977 10.5351 10.1645 10.9256 9.77397L18.0669 2.6327C18.8479 1.85165 20.1143 1.85165 20.8953 2.6327L21.3665 3.10391C22.1476 3.88496 22.1476 5.15129 21.3665 5.93234L14.2252 13.0736C13.8347 13.4641 13.2016 13.4641 12.811 13.0736L10.9256 11.1882Z" fill="currentColor"></path>
							<path d="M8.82343 12.0064L8.08852 14.3348C7.8655 15.0414 8.46151 15.7366 9.19388 15.6242L11.8974 15.2092C12.4642 15.1222 12.6916 14.4278 12.2861 14.0223L9.98595 11.7221C9.61452 11.3507 8.98154 11.5055 8.82343 12.0064Z" fill="currentColor"></path>
						</svg> {t("Edit")}</>,
					size : "sm",
					action : () => setEdit(true)
				}} />}
			</div>
		</div>
		<div className="card-body py-4">
			<div className="mb-5">
				<label className="form-label fs-7 text-gray-900">{t("Name")}</label>
				<div className="text-gray-600">
					{!edit && partner.name}
					{edit && <input 
						type="text" 
						className="form-control form-control-solid" 
						placeholder={t("Enter partner name")}
						value={data.name}
						onChange={(e) => setData({...data, name : e.target.value})} />}
				</div>
			</div>
			<div className="">
				<label className="form-label fs-7 text-gray-900">{t("Created")}</label>
				<div className="text-gray-600">
					{moment(partner.created).format("L")}
				</div>
			</div>
		</div>
	</div>
}

const mapState = (state) => {
	const user =  state.AuthReducer.user;
	const allusers =  state.ProgramReducer.allusers;

	return { user, allusers };
};

const mapDispatch = (dispatch) => ({
	
});

export default connect(mapState, mapDispatch)(CompPartnerInfo);
